import { useEffect, useState } from "react";
import { SettingApi, PagesApi, CategoryAPI } from "../api";
import { AppDataContext } from "../context/AppDataContext";

export const AppDataProvider = ({ children }) => {
	const [settings, setSettings] = useState(null);
	const [homePage, setHomePages] = useState([]);
	const [aboutPage, setAboutPages] = useState([]);
	const [servicePage, setServicePages] = useState([]);
	const [contactPage, setContactPages] = useState([]);
	const [privacyPage, setPrivacyPages] = useState([]);
	const [termPage, setTermPages] = useState([]);
	const [loading, setLoading] = useState(true);
	const [maintenance, setMaintenance] = useState(false);
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		Promise.all([
			SettingApi.getAllSettings(),
			PagesApi.getAllPages(),
			CategoryAPI.getAllCategories(),
		])
			.then(([settingsRes, pagesRes, categoriesRes]) => {
				const settingsData = settingsRes.data;
				setSettings(settingsData);
				const pages = pagesRes.data;
				setCategories(categoriesRes.data);
				setMaintenance(settingsData.maintenance === "1");
				setHomePages(pages.find((page) => page.slug === "home-page"));
				setAboutPages(pages.find((page) => page.slug === "about-us"));
				setServicePages(pages.find((page) => page.slug === "services"));
				setContactPages(pages.find((page) => page.slug === "contact-us"));
				setPrivacyPages(pages.find((page) => page.slug === "privacy-policy"));
				setTermPages(pages.find((page) => page.slug === "terms-conditions"));
			})
			.catch((err) => console.error("Error loading app data:", err))
			.finally(() => setLoading(false));
	}, []);

	return (
		<AppDataContext.Provider
			value={{
				settings,
				maintenance,
				loading,
				categories,
				homePage,
				aboutPage,
				servicePage,
				contactPage,
				privacyPage,
				termPage,
			}}
		>
			{children}
		</AppDataContext.Provider>
	);
};
